module.exports = "/images/Amazon_v2.png?dfcd1f4d99b2d0d3acfc9224ee8e5c14";